(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter', '$http', '$q'];

    function DateUtils($filter, $http, $q) {

        // Jour de coupure de la période de paie, lu une fois via /api/configs.
        // Valeur par défaut tant que la requête n'a pas répondu : 26.
        var DEFAULT_CUTOFF_DAY = 26;
        var cutoffDay = DEFAULT_CUTOFF_DAY;
        var cutoffPromise = null;

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat,
            getFirstDayOfMonth: getFirstDayOfMonth,
            getFirstDayOfPeriod: getFirstDayOfPeriod,
            getLastDayOfPeriod: getLastDayOfPeriod,
            getFirstDayOfCivilMonth: getFirstDayOfCivilMonth,
            getLastDayOfCivilMonth: getLastDayOfCivilMonth,
            loadCutoffDay: loadCutoffDay,
            invalidateCutoffDay: invalidateCutoffDay,
            getCutoffDay: getCutoffDay,
            getFirstDayOfPayrollPeriod: getFirstDayOfPayrollPeriod,
            getLastDayOfPayrollPeriod: getLastDayOfPayrollPeriod
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }

        function getFirstDayOfMonth(date) {
            var currentMonth = date.getMonth();
            var currentYear = date.getFullYear();

            var firstDayOfCurrentMonth = new Date(currentYear, currentMonth, 1);

            var lastDayOfCurrentMonth = new Date(currentYear, currentMonth + 1, 0);

            var lastSaturdayOfCurrentMonth = new Date(lastDayOfCurrentMonth);
            var dayOfWeek = lastDayOfCurrentMonth.getDay();

            lastSaturdayOfCurrentMonth.setDate(lastDayOfCurrentMonth.getDate() - ((dayOfWeek + 1) % 7));

            // Vérifier si aujourd'hui est après le dernier samedi du mois en cours
            if (date > lastSaturdayOfCurrentMonth) {
                currentMonth += 1;
                if (currentMonth > 11) {
                    currentMonth = 0;
                    currentYear += 1;
                }
            }

            return new Date(currentYear, currentMonth, 1);
        }

        function getFirstDayOfPeriod(firstDayOfMonth) {
            // dimanche précédent la 1ere semaine du mois

            var daysToSubtract = firstDayOfMonth.getDay();
            var firstSundayBeforeMonth = new Date(firstDayOfMonth);
            firstSundayBeforeMonth.setDate(firstDayOfMonth.getDate() - daysToSubtract);
            firstSundayBeforeMonth.setHours(firstSundayBeforeMonth.getHours() + 3);
            return firstSundayBeforeMonth;
        }

        function getLastDayOfPeriod(firstDayOfMonth) {
            //dernier samedi du mois
            var year = firstDayOfMonth.getFullYear();
            var month = firstDayOfMonth.getMonth();
            var lastDayOfMonth = new Date(year, month + 1, 0);

            var dayOfWeek = lastDayOfMonth.getDay();
            var daysToSubtract = dayOfWeek < 6 ? dayOfWeek + 1 : 0;

            var lastSaturdayOfMonth = new Date(lastDayOfMonth);
            lastSaturdayOfMonth.setDate(lastDayOfMonth.getDate() - daysToSubtract);

            lastSaturdayOfMonth.setHours(lastSaturdayOfMonth.getHours() + 3);
            return lastSaturdayOfMonth;
        }

        function getFirstDayOfCivilMonth(date) {
            return new Date(date.getFullYear(), date.getMonth(), 1);
        }

        function getLastDayOfCivilMonth(date) {
            return new Date(date.getFullYear(), date.getMonth() + 1, 0);
        }

        // Charge le jour de coupure depuis le back. Renvoie une promise qui
        // se résout avec la valeur. Mise en cache : appels suivants instantanés.
        function loadCutoffDay() {
            if (cutoffPromise) {
                return cutoffPromise;
            }
            cutoffPromise = $http.get('api/configs/name/payroll_cutoff_day').then(function (response) {
                if (response && response.data && response.data.value) {
                    var parsed = parseInt(response.data.value, 10);
                    if (!isNaN(parsed) && parsed >= 1 && parsed <= 28) {
                        cutoffDay = parsed;
                    }
                }
                return cutoffDay;
            }, function () {
                return cutoffDay;
            });
            return cutoffPromise;
        }

        function invalidateCutoffDay() {
            cutoffPromise = null;
        }

        function getCutoffDay() {
            return cutoffDay;
        }

        // Premier jour de la période de paie contenant `date`.
        // Ex : cutoff=26, date=10 juin -> 26 mai. date=28 juin -> 26 juin.
        function getFirstDayOfPayrollPeriod(date) {
            var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            if (d.getDate() >= cutoffDay) {
                return new Date(d.getFullYear(), d.getMonth(), cutoffDay);
            }
            return new Date(d.getFullYear(), d.getMonth() - 1, cutoffDay);
        }

        // Dernier jour de la période de paie contenant `date`.
        // = premier jour + 1 mois - 1 jour.
        function getLastDayOfPayrollPeriod(date) {
            var start = getFirstDayOfPayrollPeriod(date);
            var end = new Date(start.getFullYear(), start.getMonth() + 1, start.getDate());
            end.setDate(end.getDate() - 1);
            return end;
        }
    }

})();
